import React from "react";
import { render } from "react-dom";
// import { TransitionMotion, spring } from "react-motion";
import "./style.css"; 

/*
  EPC = Established Pharmacologic Class
  MOA = Mechanism of Action
  CS = Chemical Structure
  PE = Physiologic or Pharmacodynamic Effect
*/ 

function ciEquals(a, b) {
    return typeof a === 'string' && typeof b === 'string'
        ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
        : a === b;
}

function find_class_for_exact_match (drug_name, drug_list) {
    console.log (drug_name);
    console.log (drug_list);
    for (const drug of drug_list) {
        if (ciEquals(drug_name, drug.generic_name) || ciEquals(drug_name, drug.brand_name)) {
            // Only report a pharm class if we have an exact match. This
            // is because search returns an array of drugs
            // where the drug name may be part of a combo.
            if ('undefined' !== typeof drug.pharm_class) {
                return (drug.pharm_class);
            }
        }
    }
    return ("");
}

function make_pharm_list (pharm_classes) {
    var rows = [];
    var moa = [];
    var epc = [];
    var cs  = [];
    var pe  = [];
    if (pharm_classes === "") {
        rows.push({text:"No drug class information found", class: "h1"});
        return (rows);
    }
    for (const cls of pharm_classes) {
        if (cls.toLowerCase().includes("[moa]")) {
            moa.push({text:cls, class:"item"});
            continue;
        } 
        if (cls.toLowerCase().includes("[epc]")) {
            epc.push({text:cls, class:"item"});
            continue;
        }
        if (cls.toLowerCase().includes("[cs]")) {
            cs.push({text:cls, class:"item"});
            continue;
        }
        if (cls.toLowerCase().includes("[pe]")) {
            pe.push({text:cls, class:"item"});
            continue;
        }
    }
    if (moa.length > 0) {
        rows.push({text:"Mechanism of Action", class: "h1"});
        rows = rows.concat(moa);
    }
    if (epc.length > 0) {
        rows.push({text:"Established Pharmacological Class", class: "h1"});
        rows = rows.concat(epc);
    }
    if (cs.length > 0) {
        rows.push({text:"Chemical Structure", class: "h1"});
        rows = rows.concat(cs);
    }
    if (pe.length > 0) {
        rows.push({text:"Physiologic Effect", class: "h1"});
        rows = rows.concat(pe);
    }
    return (rows);
}

class Input extends React.Component {
  constructor(props) {
    super(props);

      this.state = {
          drugList: null,
          active: (props.locked && props.active) || false,
          value: props.value || "",
          error: props.error || "",
          label: props.label || "Label"
      };
  }

  changeValue(event) {
    const value = event.target.value;
    this.setState({ value, error: "" });
  }

    handleKeyPress(event) {
        if (event.which === 13) {
            console.log("Drug search: " + this.state.value);
            fetch("https://api.fda.gov/drug/ndc.json?search=\""+this.state.value+"\"&limit=200")
                .then (res => res.json())
                .then(result => {
                    console.log(result);
                    var pharm_classes = find_class_for_exact_match(this.state.value, result.results);
                    // var pharm_classes = result.results[0].pharm_class;
                    var rows = make_pharm_list(pharm_classes);
                    console.log(rows);
                    this.setState({
                        drugList: rows});
                });
            event.preventDefault();
            // this.setState({ value: this.props.predicted });
        }
    }

  render() {
    const { active, value, error, label } = this.state;
    const { predicted, locked } = this.props;
    const fieldClassName = `field ${(locked ? active : active || value) &&
      "active"} ${locked && !active && "locked"}`;

    return (
      <div className={fieldClassName}>
        {active &&
          value &&
          predicted &&
          predicted.includes(value) && <p className="predicted">{predicted}</p>}
        <input
          id={1}
          type="text"
          value={value}
          placeholder={label}
          onChange={this.changeValue.bind(this)}
          onKeyPress={this.handleKeyPress.bind(this)}
          onFocus={() => !locked && this.setState({ active: true })}
          onBlur={() => !locked && this.setState({ active: false })}
        />
        <label htmlFor={1} className={error && "error"}>
          {error || label}
        </label>
                       {
                    this.state.drugList == null ?
                        <div></div>
                        :
                        <div>{this.state.drugList.map((drug, index) => (
                                <div className={drug.class} key={index}>{drug.text}</div>
                        ))}
                    </div>
                }
      </div>
    );
  }
}

render (
  <Input
    id={1}
    label="Enter drug (generic or brand name)"
    predicted=""
    locked={false}
    active={false}
  />,
  document.getElementById("app")
);


